import api from "./axios";

// Helper function to extract error message from API response
export const getUserErrorMessage = (error) => {
  if (error && error.response && error.response.data) {
    if (error.response.data.message) {
      return error.response.data.message;
    }
    if (
      error.response.data.errors &&
      Array.isArray(error.response.data.errors)
    ) {
      return error.response.data.errors[0];
    }
    if (
      error.response.data.errors &&
      typeof error.response.data.errors === "object"
    ) {
      const firstError = Object.values(error.response.data.errors)[0];
      if (Array.isArray(firstError)) {
        return firstError[0];
      }
      return String(firstError);
    }
  }
  return error?.message || "An unexpected error occurred";
};

// Users API service
const usersApi = {
  // Get all users
  getAll: async (isActive = true) => {
    try {
      const response = await api.get(`/users?IsActive=${isActive}`);
      return response.data;
    } catch (error) {
      return { error: getUserErrorMessage(error) };
    }
  },

  // Get user by ID
  getById: async (id) => {
    try {
      const response = await api.get(`/users/${id}`);
      return response.data;
    } catch (error) {
      return { error: getUserErrorMessage(error) };
    }
  },

  // Create new user
  createInitial: async (userData) => {
    try {
      const response = await api.post("/users/create-initial", userData);
      return response.data;
    } catch (error) {
      return { error: getUserErrorMessage(error) };
    }
  },

  // Update user
  update: async (id, userData) => {
    try {
      const response = await api.put(`/users/${id}`, userData);
      return response.data;
    } catch (error) {
      return { error: getUserErrorMessage(error) };
    }
  },

  // Delete user
  delete: async (id) => {
    try {
      const response = await api.delete(`/users/${id}`);
      return response.data;
    } catch (error) {
      return { error: getUserErrorMessage(error) };
    }
  },

  // Get chart data
  getChartData: async (period = "7days", startDate, endDate) => {
    try {
      const response = await api.get("/users/chart-data", {
        params: { period, startDate, endDate },
      });
      return response.data;
    } catch (error) {
      return { error: getUserErrorMessage(error) };
    }
  },
};

export default usersApi;
